<template>
  <FormulateForm
    :name="formName"
    v-model="formValues"
    @submit="submit"
    class="bg-gray-100 py-4 px-6 mb-8"
  >
    <h3 v-if="!edit" class="font-bold text-xl mb-4">
      Add Campaign
    </h3>

    <FormulateInput
      name="name"
      type="text"
      label="Campaign name"
      placeholder="Campaign name"
      validation="required"
    />

    <FormulateErrors />

    <base-button type="submit" :loading="sending">
      {{ edit ? 'Save' : 'Add Campaign' }}
    </base-button>
  </FormulateForm>
</template>

<script>
export default {
  props: {
    campaign: Object,
  },
  data() {
    return {
      formName: `campaignsForm${this.campaign ? this.campaign.id : ''}`,
      formValues: this.campaign || {},
      sending: false,
    };
  },
  computed: {
    edit() {
      return Boolean(this.campaign);
    },
  },
  methods: {
    async submit(data) {
      try {
        this.$formulate.resetValidation(this.formName);
        this.sending = true;
        const action = this.edit ? 'updateCampaign' : 'addCampaign';
        await this.$store.dispatch(`company/campaign/${action}`, data);
        this.$emit('saved');
      } catch (error) {
        this.$formulate.handle(error, this.formName);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
